import type { Die, Predicate } from './types';

/** Evaluate a single-die predicate against a die face.
 *
 * Exhaustive over the `Predicate` union — when a new variant is added the
 * compiler flags the `assertNever` call below. There is no `default` clause
 * that would silently swallow new variants. */
export function matches(die: Die, predicate: Predicate): boolean {
  switch (predicate.kind) {
    case 'min':
      return die >= predicate.value;
    case 'max':
      return die <= predicate.value;
    case 'exact':
      return die === predicate.value;
    case 'parity':
      return predicate.value === 'even' ? die % 2 === 0 : die % 2 === 1;
  }
  return assertNever(predicate);
}

function assertNever(x: never): never {
  throw new Error(`unhandled predicate variant: ${JSON.stringify(x)}`);
}
